import React from 'react'
import { Routes, Route } from 'react-router-dom';
import List from './List';
import Details from './Details';
import AddEdit from './AddEdit';
import { Header } from 'semantic-ui-react'
export { default as CustomEndScreensModal } from './CustomEndScreensModal';

function Blogs() {

  return (
    <>
      <Header as='h2' style={{ marginTop: "20px" }}>
        Questions
        <Header.Subheader>
          Manage questions for Survey
        </Header.Subheader>
       
      </Header>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="details/:id" element={<Details />} />
        <Route path="new" element={<AddEdit />} />
        <Route path="edit/:id" element={<AddEdit />} />
      </Routes>
    </>
  );
}

export default Blogs;
